import React, { Component } from 'react';
import { getToken } from '../../functions/app_functions.js';
import ForminputText from '../forminput/forminput_text.js';
import ForminputTextbox from '../forminput/forminput_textbox.js';
import Video from "../../media/images/home/home_benefits.mp4"
import { ReactComponent as IconCheckmark } from '../../media/icons/checkmark.svg';


export default class CreateTrip extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            num_budget: 5, 
            page: 1,
            title: "",
            category: [],
            size: [],
            genai_generating: false,
            genai_trip_id: null,
            genai_seconds_left: 0,
            user_trips: null,
            num_trips_genai_last_month: null
        };

        this.loadUserGenAICount = this.loadUserGenAICount.bind(this);
        this.setPage = this.setPage.bind(this);
        this.setFormValue = this.setFormValue.bind(this);
        this.toggleTripCategory = this.toggleTripCategory.bind(this);
        this.toggleTargetGroup = this.toggleTargetGroup.bind(this);
        this.verifyTripData = this.verifyTripData.bind(this);
        this.submitCreateTrip = this.submitCreateTrip.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.submitFormGenAI = this.submitFormGenAI.bind(this);
        this.startGenAiCountdown = this.startGenAiCountdown.bind(this);
    }


    componentDidMount() {
        // Load user trip data
        if (this.props.user_id && this.state.user_trips == null) {
            this.loadUserGenAICount(this.props.user_id);
        }
    }


    componentWillUnmount() {
        if (this.genaiTimer) clearInterval(this.genaiTimer);
    }


    formatSeconds(seconds) {
        const s = Math.max(0, seconds);
        const mm = String(Math.floor(s / 60)).padStart(2, "0");
        const ss = String(s % 60).padStart(2, "0");
        return `${mm}:${ss}`;
    }


    startGenAiCountdown(trip_id) {
        // 2:43 = 163 seconds
        const TOTAL = 163;

        // Clear any prior timer
        if (this.genaiTimer) clearInterval(this.genaiTimer);

        this.setState({
            genai_generating: true,
            genai_trip_id: trip_id,
            genai_seconds_left: TOTAL
        });

        this.genaiTimer = setInterval(() => {
            this.setState(prev => {
                const next = prev.genai_seconds_left - 1;

                if (next <= 0) {
                    clearInterval(this.genaiTimer);
                    this.genaiTimer = null;

                    // Stop loading + redirect
                    this.props.unsetLoading();
                    this.props.goToPage("/trip/" + trip_id);

                    return { genai_seconds_left: 0, genai_generating: false };
                }

                return { genai_seconds_left: next };
            });
        }, 1000);
    }


    async loadUserGenAICount() {
        try {
            
            // Send request
            var response = await fetch(this.props.baseUrl + "/getusergenaicount", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                }
            });
            // Process response
            response = await response.json();
            if (response.status == 200) {
                this.setState({
                    num_trips_genai_last_month: response.value
                });
            } else {
                // Track error
                var name = "";
                var message = "Could not load user data. Please try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not load user data. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Account_loadUserTripData");
        }
    }


    setPage(page) {
        this.setState({ page: page });
    }


    setFormValue(label, value) {
        this.setState({
            [label]: value
        });
    }


    toggleTripCategory(category) {
        try {
            var categories = this.state.category;
            if (categories.includes(category)) {
                if (categories.length <= 1) {
                    var name = "Error";
                    var message = "You need to select at least 1 trip category.";
                    this.props.setError(name, message);
                    return false;
                }
                var index = categories.indexOf(category);
                if (index !== -1) {
                    categories.splice(index, 1);
                }
            } else {
                categories.push(category);
            }
            this.setState({
                category: categories
            });
        } catch (error) {
            console.log(error);
            // Track error
            var name = "Client error";
            var message = "Could not update trip data.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Createtrip_toggleTripCategory");
        }
    }


    toggleTargetGroup(target) {
        try {
            var targets = this.state.size;
            if (targets.includes(target)) {
                if (targets.length <= 1) {
                    var name = "Error";
                    var message = "You need to select at least 1 target group.";
                    this.props.setError(name, message);
                    return false;
                }
                var index = targets.indexOf(target);
                if (index !== -1) {
                    targets.splice(index, 1);
                }
            } else {
                targets.push(target);
            }
            this.setState({
                size: targets
            });
        } catch (error) {
            console.log(error);
            // Track error
            var name = "Client error";
            var message = "Could not update trip data.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Createtrip_toggleTargetGroup");
        }
    }


    verifyTripData(data_in) {
        const data = data_in;
        var return_value = data;
        try {
            // Check if title is set
            if (!data.title || data.title.length < 5 || data.title.length > 200) {
                var name = "";
                var message = "Your trip title needs to be between 5 and 200 characters.";
                this.props.setError(name, message);
                return_value = false;
                return return_value;
            }
            // Check if category is set
            if (!data.category || data.category.length < 1) {
                var name = "";
                var message = "Your trip needs to have at least 1 category attribute (e.g., adventure, beach, safari).";
                this.props.setError(name, message);
                return_value = false;
                return return_value;
            }
            // Check if target is set
            if (!data.target || data.target.length < 1) {
                var name = "";
                var message = "Your trip needs to have at least 1 target group (e.g., solo travelers, couples).";
                this.props.setError(name, message);
                return_value = false;
                return return_value;
            }
        } catch (error) {
            // Track error
            var name = "Website error";
            var message = "Could not verify data completeness. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Createtrip_verifyTripData");
            return_value = false;
        } finally {
            return return_value;
        }
    }


    async submitCreateTrip(data) {
        this.props.setLoading();
        try {
            // Send request
            var response = await fetch(this.props.baseUrl + "/createtrip", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    data: data,
                    user_id: this.state.user_id
                }),
            });
            // Process response
            response = await response.json();
            // Check token validity
            if ('error' in response && (response["error"] == "email")) {
                // Track error
                var name = "Error";
                var message = "You need to verify your email before you can create a trip.";
                this.props.setError(name, message);
                this.props.unsetLoading();
            } else {
                // Process data
                var data = response.value;
                if (data.status) {
                    // Track event
                    this.props.logEvent("User activity", "Trip created");
                    // Forward to trip page
                    var trip_id = data.trip_id;
                    this.props.goToPage("/trip/" + trip_id);
                    this.props.unsetLoading();
                } else {
                    // Track error
                    var name = "Server error";
                    var message = "Could not create trip. Please try again later.";
                    this.props.setError(name, message);
                    // Track event
                    this.props.logEvent("Client error", "Createtrip_submitCreateTrip");
                    this.props.unsetLoading();
                }
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "Server error";
            var message = "Could not create trip. Please try again later.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Createtrip_submitCreateTrip");
            this.props.unsetLoading();
        }
    }


    async submitCreateTripGenAI(data) {
        this.props.setLoading();
        try {
            // Send request
            var response = await fetch(this.props.baseUrl + "/createtripgenai", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    data: data,
                    user_id: this.state.user_id
                }),
            });
            // Process response
            response = await response.json();
            // Check token validity
            if ('error' in response && (response["error"] == "email")) {
                // Track error
                var name = "Error";
                var message = "You need to verify your email before you can create a trip.";
                this.props.setError(name, message);
                this.props.unsetLoading();
            } else {
                // Process data
                var data = response;
                if (data.status == 200) {
                    // Track event
                    this.props.logEvent("User activity", "Trip created with GenAI");
                    var trip_id = data.value;
                    // Start timer for creation and forward to trip page
                    this.startGenAiCountdown(trip_id);
                    // Forward to trip page
                    this.props.unsetLoading();
                } else {
                    // Track error
                    var name = "Server error";
                    var message = "Could not create trip. Please try again later.";
                    this.props.setError(name, message);
                    // Track event
                    this.props.logEvent("Client error", "Createtrip_submitCreateTripGenAI");
                    this.props.unsetLoading();
                }
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            console.log(error);
            var name = "Server error";
            var message = "Could not create trip. Please try again later.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Createtrip_submitCreateTripGenAI");
            this.props.unsetLoading();
        }
    }


    submitForm() {
        const data = {
            title: this.state.title,
            category: this.state.category,
            target: this.state.size
        }
        const validated = this.verifyTripData(data);
        if (validated) {
            this.submitCreateTrip(validated);
        }
    }



    submitFormGenAI() {
        const data = this.state.genai_instructions;
        if (data && data.length > 100) {
            this.submitCreateTripGenAI(data);
        } else {
            var name = "";
            var message = "Please provide more detailed instructions for the GenAI to create your trip with at least 100 characters.";
            this.props.setError(name, message);
            return false;
        }
        return true;
    }

    render() {

        return (
            <div className="content-container">
                <div className="form-container form-container--with-background">
                    <div className="form__background form__background--trip">
                        {/* <video width="320" height="240" className="home__valueprop__video-inner" autoPlay muted controls={false}>
                            <source src={Video} category="video/mp4" />
                        </video> */}
                    </div>
                    <div className="form__overlay"></div>
                    <div className="form__popup-container">
                        <div className="form__popup">

                            {(this.state.page === 1 || this.state.page === 3) && !this.state.genai_generating &&
                                <div className="trip__popup__section">
                                    <div className="trip__popup__switch-container">
                                        <div onClick={() => this.setPage(1)} className={"trip__popup__switch__button" + (this.state.page == 1 ? " trip__popup__switch__button--selected" : "")}>
                                            <div className="trip__popup__switch__button__icon">
                                                <IconCheckmark className="trip__popup__switch__button__icon-inner" />
                                            </div>
                                            <div className="trip__popup__switch__button__label">
                                                Create from scratch
                                            </div>
                                        </div>
                                        <div onClick={() => this.setPage(3)} className={"trip__popup__switch__button" + (this.state.page == 3 ? " trip__popup__switch__button--selected" : "")}>
                                            <div className="trip__popup__switch__button__icon">
                                                <IconCheckmark className="trip__popup__switch__button__icon-inner" />
                                            </div>
                                            <div className="trip__popup__switch__button__label">
                                                Create using GenAI (BETA)
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            {this.state.page === 1 &&
                                <div className="trip__popup__title text-subtitle">
                                    We only need the basics to get started
                                </div>
                            }

                            {this.state.page === 2 &&
                                <div className="trip__popup__title text-subtitle">
                                    Next we'll define the settings for this trip
                                </div>
                            }

                            {this.state.page === 3 && !this.state.genai_generating &&
                                <div className="trip__popup__element">
                                    <div className="trip__popup__element__content">
                                        You can now provide instructions to our GenAI to create a trip itinerary for you. The more detailed your instructions, the better the result will be.
                                        The resulting trip is only a starting point - you will need to adjust it based on your expert knowledge that our GenAI does not have.
                                    </div>
                                    <div className="trip__popup__element">
                                        <div className="trip__popup__element__content">
                                            {<div className="trip__popup__element__label text-subtitle">
                                                Briefly describe the trip you want to create
                                            </div>}
                                            <div className="trip__popup__element__content">
                                                <ForminputTextbox
                                                    name={"genai_instructions"}
                                                    label={""}
                                                    default_value={""}
                                                    setFormValue={this.setFormValue.bind(this)}
                                                    required={true}
                                                    note={"Describe the trip you want to create. Our GenAI will then create a Guidr trip itinerary for you to get started with."}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="trip__popup__element__content">
                                        You have <span className="text-bold text-color-primary">{Math.max(this.state.num_budget - this.state.num_trips_genai_last_month, 0)}</span> GenAI calls left. This number is reset each month. This feature is currently in BETA. Results may vary.
                                    </div>
                                </div>
                            }


                            {this.state.page === 3 && this.state.genai_generating && (
                                <div className="trip__popup__element">
                                    <div className="trip__popup__element__content text-subtitle">
                                        Creating your trip… redirecting you in {this.formatSeconds(this.state.genai_seconds_left)}
                                    </div>
                                </div>
                            )}


                            {this.state.page === 3 && this.state.genai_generating && (
                                <div className="trip__popup__element">
                                    <div className="trip__popup__element__content">
                                        You don't have to wait. You can do something else and find your new trip in your account details once it is available.
                                    </div>
                                </div>
                            )}


                            {this.state.page === 1 &&
                                <div className="trip__popup__section">
                                    {/* <div className="trip__popup__element">
                                    Please provide a title and indicate the category of trip you will create an itinerary for. You will be able to add details later.  
                                </div> */}
                                    <div className="trip__popup__element">
                                        {<div className="trip__popup__element__label text-subtitle">
                                            Title
                                        </div>}
                                        <div className="trip__popup__element__content">
                                            <ForminputText
                                                name={"title"}
                                                label={""}
                                                default_value={this.state.title}
                                                setFormValue={this.setFormValue.bind(this)}
                                                required={true}
                                                note={"Give your trip a title with 5-200 characters."}
                                            />
                                        </div>
                                    </div>
                                    <div className="trip__popup__element">
                                        <div className="trip__popup__element__label text-subtitle">
                                            Trip category
                                        </div>
                                        <div className="trip__popup__element__content trip__labelbar">
                                            {this.props.trip_categories.map((category, i) => (
                                                <div key={i} onClick={() => this.toggleTripCategory(category)} className={"trip__label" + (this.state.category.includes(category) ? " trip__label--selected" : " trip__label--unselected")}>
                                                    {category}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="trip__popup__element">
                                        <div className="trip__popup__element__label text-subtitle">
                                            Target group
                                        </div>
                                        <div className="trip__popup__element__content trip__labelbar">
                                            {this.props.trip_targets.map((target, i) => (
                                                <div key={i} onClick={() => this.toggleTargetGroup(target)} className={"trip__label" + (this.state.size.includes(target) ? " trip__label--selected" : " trip__label--unselected")}>
                                                    {target}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            }

                            {this.state.page === 2 &&
                                <div className="trip__popup__section">
                                    <div className="trip__popup__element">
                                        {<div className="trip__popup__element__label text-subtitle">
                                            Do you want to make this trip publicly available?
                                        </div>}
                                        <div className="trip__popup__element__content">
                                            Switch
                                        </div>
                                    </div>
                                </div>
                            }

                            <div className="trip__popup__section">
                                <div className="trip__popup__element trip__popup__buttonbox">
                                    {/* <button disabled={this.state.page === 1 ? true : false} onClick={() => this.setPage(this.state.page - 1)} className={"button" + (this.state.page === 1 ? " button-inactive" : " button-primary-light")}>
                                        Go back
                                    </button> */}
                                    {this.state.page == 2 &&
                                        <button onClick={() => this.setPage(this.state.page + 1)} className={"button button-primary trip__popup__buttonbox__button--single-button"}>
                                            Continue
                                        </button>
                                    }
                                    {this.state.page === 1 &&
                                        <button onClick={this.submitForm} className={"button button-primary trip__popup__buttonbox__button--single-button"}>
                                            Create trip
                                        </button>
                                    }
                                    {this.state.page === 3 && !this.state.genai_generating && this.state.num_trips_genai_last_month < this.state.num_budget && 
                                        <button onClick={this.submitFormGenAI} className={"button button-primary trip__popup__buttonbox__button--single-button"}>
                                            Create trip
                                        </button>
                                    }
                                    {/* this.state.page === 3 && this.state.genai_generating &&
                                        <button className={"button button-primary trip__popup__buttonbox__button--single-button button-inactive"}>
                                            Trip being created…
                                        </button> */
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}
